import Link from 'next/link';
import { useRouter } from 'next/router';
import React from 'react';
import { withTranslation } from 'next-i18next';
import { getClassName } from '../../../nav-helpr';

const StudentHeaderDesktopLeftPart = ({ t }) => {
  const { pathname: currentPath } = useRouter();
  return (
    <div className="hidden md:ml-6 md:flex md:space-x-8">
      {/* Current: "border-indigo-500 text-gray-900", Default: "border-transparent text-default hover:border hover:text-gray-700" */}
      <Link legacyBehavior href="/s/dashboard">
        <a className={getClassName('/s/dashboard', currentPath)}>
          {t('service.header.dashboard')}
        </a>
      </Link>
      <Link legacyBehavior href="/s/booking-calendar">
        <a className={getClassName('/s/booking-calendar', currentPath)}>
          {t('links.book')}
        </a>
      </Link>
      <Link legacyBehavior href="/tutors">
        <a className={getClassName('/tutors', currentPath)}>
          {t('service.header.tutors')}
        </a>
      </Link>
      <Link legacyBehavior href="/s/materials">
        <a className={getClassName('/s/materials', currentPath)}>
          {t('service.header.materials')}
        </a>
      </Link>
    </div>
  );
};

const wrapped = withTranslation('common')(StudentHeaderDesktopLeftPart);

export default wrapped;
